import api from './api'

export const memberService = {
  getAll: (params = {}) => {
    return api.get('/members', { params })
  },

  getById: (nba) => {
    return api.get(`/members/${nba}`)
  },

  create: (data) => {
    return api.post('/members', data)
  },

  update: (nba, data) => {
    return api.put(`/members/${nba}`, data)
  },

  activate: (nba, data) => {
    return api.post(`/members/${nba}/activate`, data)
  },

  exit: (nba, data) => {
    return api.post(`/members/${nba}/exit`, data)
  }
}
